export default function HrgsDashboardReportRoutes(staticTitle) {
    return [
        {
            path: '/hrgs/dashboard-report',
            name: 'hrgs-dashboard-report',
            meta: {
                title: `${staticTitle} - HR & GS`
            },
            component: () => {
                return import('@/views/hrgs/dashboard-report/index.vue');
            },
            children: [
                {
                    path: '/hrgs/dashboard-report/hrgs-dashboard',
                    name: 'hrgsdashboard',
                    meta: {
                        title: `${staticTitle} - HR & GS - Dashboard`
                    },
                    component: () => {
                        return import('@/views/hrgs/dashboard-report/dashboard/index.vue');
                    }
                },
                {
                    path: '/hrgs/dashboard-report/hrgs-report',
                    name: 'hrgsreport',
                    meta: {
                        title: `${staticTitle} - HR & GS - Report`
                    },
                    component: () => {
                        return import('@/views/hrgs/dashboard-report/report/index.vue');
                    }
                }
            ]
        }
    ];
}
